import TYPES from "./types";

const getGeneratedImagesError = () => ({
  type: TYPES.GET_GENERATED_IMAGES_ERROR,
  //TODO: Helper method to create meaningful messages based on the error
  error: "Unable to get generated images",
});

const getGeneratedImagesStarted = () => ({
  type: TYPES.GET_GENERATED_IMAGES_STARTED,
});

const getGeneratedImagesSuccess = (profile) => ({
  type: TYPES.GET_GENERATED_IMAGES_SUCCESS,
  profile,
});

const selectGeneratedImage = (image) => ({
  type: "generator/selectGeneratedImage",
  image,
});

const selectCategory = (category) => ({
  type: "generator/selectCategory",
  category,
});

const profileActions = {
  getGeneratedImagesError,
  getGeneratedImagesStarted,
  getGeneratedImagesSuccess,
  selectGeneratedImage,
  selectCategory,
};

export default profileActions;
